module.exports = __webpack_public_path__ + "img/logo-keyvue-basic-plus.3d09045c.svg";